import React from 'react';

const Contact = () => {


  return (
    <>
      <div className="container my-4">
        <div className="row">
          <div className="col-md-2"></div>
          <div className="col-md-8">
            <form className='contact_form text-center' action='https://youtube.com/@waleedcodes'>
              <h2 className='fw-bold py-3'>Get In Touch</h2>
              <div className="d-md-flex">
                <input type="text" className="form-control mx-md-2 my-md-2 my-3" placeholder='First Name' required />
                <input type="text" className="form-control mx-md-2 my-md-2 my-3" placeholder='Last Name' required />
              </div>
              <div className="d-md-flex">
                <input type="email" className="form-control mx-md-2 my-md-2 my-3" placeholder='Email' required />
                <input type="number" className="form-control mx-md-2 my-md-2 my-3" placeholder='Phone Number' required />
              </div>
              <div className="mx-md-2  my-md-2 my-3">
                <input type="text" className="form-control my-md-2 my-3" placeholder='Address' required />
              </div>
              <div className="mx-md-2 my-3">
                <textarea className="form-control" rows="4" placeholder='Types Your Message here' required></textarea>
              </div>
              <div className="text-center py-2">
                <button type="submit" className="btn rounded-0 py-2 px-4 fs-5 bg-dark-subtle">Submit</button>
              </div>
            </form>
          </div>
          <div className="col-md-2"></div>
        </div>
      </div >
    </>
  )
}

export default Contact
